import clsx from "clsx";
import shape from "../../assets/img/shapes/zebra-shape-01.webp";


const ZebraShape01 = ( props:any ) => {

    return (
        <div className={clsx("rmdr-zebra-shape-01", props.className)}>
            <img src={shape} alt="rmdr-zebra-shape-01" loading="lazy" width={236} height={376} />
        </div>
    )

}

export default ZebraShape01;
